export const embroideryPositionOptions = [
  { label: "親指", value: "親指", cost: 2000 },
  { label: "小指", value: "小指", cost: 2000 },
  { label: "平裏一段目", value: "平裏一段目", cost: 2000 },
  { label: "平裏二段目", value: "平裏二段目", cost: 2000 },
  { label: "土手裏", value: "土手裏", cost: 2000 },
];

export const fontOptions = [
  {
    label: "楷書体",
    value: "楷書体",
    image: require("@/assets/img/fontSample/standard-font-style.png"),
    fontDescription: "書体カラー:金色 + カゲフチ:なし",
  },
  {
    label: "行書体",
    value: "行書体",
    image: require("@/assets/img/fontSample/line-font-style.png"),
    fontDescription: "書体カラー:ブルー + カゲカラー:オレンジ",
  },
  {
    label: "ブロック体(日本語非対応)",
    value: "ブロック体",
    image: require("@/assets/img/fontSample/block-font-style.png"),
    fontDescription: "書体カラー:サックス + フチカラー:銀糸",
  },
  {
    label: "筆記体(日本語非対応)",
    value: "筆記体",
    image: require("@/assets/img/fontSample/writing-font-style.png"),
    fontDescription: "書体カラー:Rピンク + カゲフチ:なし",
  },
  {
    label: "フラッシュ体(日本語非対応)",
    value: "フラッシュ体",
    image: require("@/assets/img/fontSample/brush-font-style.png"),
    fontDescription: "書体カラー:Lグリーン + カゲカラー:ピンク",
  },
  {
    label: "オールドイングリッシュ体(日本語非対応)",
    value: "オールドイングリッシュ体",
    image: require("@/assets/img/fontSample/old-english-font-style.png"),
    fontDescription: "書体カラー:グリーン + フチカラー:イエロー",
  },
];

export const fontColorOptions = [
  { label: "ブラック", value: "ブラック", isColor: true },
  { label: "ネイビー", value: "ネイビー", isColor: true },
  { label: "ブルー", value: "ブルー", isColor: true },
  { label: "サックス", value: "サックス", isColor: true },
  { label: "オレンジ", value: "オレンジ", isColor: true },
  { label: "レッド", value: "レッド", isColor: true },
  { label: "Rピンク", value: "Rピンク", isColor: true },
  { label: "Sピンク", value: "Sピンク", isColor: true },
  { label: "パープル", value: "パープル", isColor: true },
  { label: "イエロー", value: "イエロー", isColor: true },
  { label: "Lイエロー", value: "Lイエロー", isColor: true },
  { label: "コルク", value: "コルク", isColor: true },
  { label: "チョコ", value: "チョコ", isColor: true },
  { label: "グリーン", value: "グリーン", isColor: true },
  { label: "Lグリーン", value: "Lグリーン", isColor: true },
  { label: "グレー", value: "グレー", isColor: true },
  { label: "ホワイト", value: "ホワイト", isColor: true },
  { label: "キャメル", value: "キャメル", isColor: true },
  { label: "Lシルバー", value: "Lシルバー", isColor: true },
  { label: "Lゴールド", value: "Lゴールド", isColor: true },
  { label: "銀糸", value: "銀糸", isColor: true },
  { label: "金糸", value: "金糸", isColor: true },
];

export const shadowEdgeOptions = [
  { label: "なし", value: "カゲ・フチ: なし" },
  { label: "カゲ", value: "カゲ・フチ: カゲ" },
  { label: "フチ", value: "カゲ・フチ: フチ" },
];

export const shadowColorOptions = [
  { label: "ブラック", value: "ブラック", isColor: true },
  { label: "ネイビー", value: "ネイビー", isColor: true },
  { label: "ブルー", value: "ブルー", isColor: true },
  { label: "サックス", value: "サックス", isColor: true },
  { label: "オレンジ", value: "オレンジ", isColor: true },
  { label: "レッド", value: "レッド", isColor: true },
  { label: "Rピンク", value: "Rピンク", isColor: true },
  { label: "Sピンク", value: "Sピンク", isColor: true },
  { label: "パープル", value: "パープル", isColor: true },
  { label: "イエロー", value: "イエロー", isColor: true },
  { label: "Lイエロー", value: "Lイエロー", isColor: true },
  { label: "コルク", value: "コルク", isColor: true },
  { label: "チョコ", value: "チョコ", isColor: true },
  { label: "グリーン", value: "グリーン", isColor: true },
  { label: "Lグリーン", value: "Lグリーン", isColor: true },
  { label: "グレー", value: "グレー", isColor: true },
  { label: "ホワイト", value: "ホワイト", isColor: true },
  { label: "キャメル", value: "キャメル", isColor: true },
  { label: "Lシルバー", value: "Lシルバー", isColor: true },
  { label: "Lゴールド", value: "Lゴールド", isColor: true },
  { label: "銀糸", value: "銀糸", isColor: true },
  { label: "金糸", value: "金糸", isColor: true },
];

export const edgeColorOptions = [
  { label: "ブラック", value: "ブラック", isColor: true },
  { label: "ネイビー", value: "ネイビー", isColor: true },
  { label: "ブルー", value: "ブルー", isColor: true },
  { label: "サックス", value: "サックス", isColor: true },
  { label: "オレンジ", value: "オレンジ", isColor: true },
  { label: "レッド", value: "レッド", isColor: true },
  { label: "Rピンク", value: "Rピンク", isColor: true },
  { label: "Sピンク", value: "Sピンク", isColor: true },
  { label: "パープル", value: "パープル", isColor: true },
  { label: "イエロー", value: "イエロー", isColor: true },
  { label: "Lイエロー", value: "Lイエロー", isColor: true },
  { label: "コルク", value: "コルク", isColor: true },
  { label: "チョコ", value: "チョコ", isColor: true },
  { label: "グリーン", value: "グリーン", isColor: true },
  { label: "Lグリーン", value: "Lグリーン", isColor: true },
  { label: "グレー", value: "グレー", isColor: true },
  { label: "ホワイト", value: "ホワイト", isColor: true },
  { label: "キャメル", value: "キャメル", isColor: true },
  { label: "Lシルバー", value: "Lシルバー", isColor: true },
  { label: "Lゴールド", value: "Lゴールド", isColor: true },
  { label: "銀糸", value: "銀糸", isColor: true },
  { label: "金糸", value: "金糸", isColor: true },
];
